package com.milta.core.localization.translations.ro

import com.milta.core.localization.OcrScanStrings

internal val OcrScan = OcrScanStrings(
    scanTitle = "Scanați un document",
    reviewTitle = "Verificați datele",
    fileSentSuffix = "trimisă chiar acum",
    analysingTitle = "Se citește documentul…",
    analysingSubtitle = "Detectăm livrările de pe fotografie. Durează doar câteva secunde.",
    deliveriesDetectedSuffix = "livrări detectate",
    toCompleteSuffix = "de completat",
    reviewHint = "Completați livrările semnalate înainte de a le adăuga la traseu",
    addressMissingWarning = "Adresă lipsă",
    nameMissingWarning = "Nume lipsă",
    recipientMissingPlaceholder = "Destinatar nedetectat",
    phoneNotDetectedNote = "Telefon nedetectat — adăugarea nu este blocată",
    deadlineLabelPrefix = "Oră limită",
    completeLinkLabel = "Completați",
    addToRouteButtonPrefix = "Adăugați la traseu",
    correctionRecipientLabel = "Destinatar",
    correctionAddressLabel = "Adresă",
    correctionPhoneLabel = "Telefon",
    correctionDeadlineLabel = "Oră limită",
    unreadableTitle = "Fotografie ilizibilă.",
    unreadableMessage = "Nu am detectat nicio livrare pe această imagine — faceți o fotografie bine cadrată și bine luminată.",
    retakePhotoButton = "Faceți o nouă fotografie",
    manualEntryButton = "Introduceți manual",
    rateLimitTitle = "Prea multe scanări efectuate recent.",
    rateLimitMessage = "Încercați din nou puțin mai târziu sau completați această livrare manual în așteptare.",
    rateLimitRetakeUnavailableLabel = "Faceți o nouă fotografie — indisponibil momentan",
)
